module.exports = __webpack_public_path__ + "static/media/overcast.4a340c81.png";